import globalVars from 'utils/globalVars';

export type TEnv = 'dev' | 'proxy' | 'staging' | 'test' | 'live';

const getEnv = () => (process?.env?.ENV || globalVars.env || 'dev') as TEnv;

export default getEnv;
